module.exports = __webpack_public_path__ + "static/media/map-marker-minus.630df326.svg";